<template>
  <v-container class="mt-10" v-if="employee">
    <div class="display-1">Annuaire HEIG-VD</div>
    <v-divider class="my-10"></v-divider>
    <v-row>
      <v-col cols="12" sm="4">
        <v-card class="pa-5" outlined>
          <v-card-text>
            <div class="subtitle-2">FONCTIONS</div>
            <div v-for="(role, index) in employee.roles" :key="`role-${index}`">
              <v-checkbox
                class="px-3 my-0"
                :label="
                  shortNameDisplay.indexOf(role.longName) > -1
                    ? role.shortName
                    : role.longName
                "
                v-model="role.config.whitepages"
                color="blue-grey lighten-1"
                @click="autosave"
                disabled
                dense
              ></v-checkbox>
            </div>
            <div
              class="mt-5 subtitle-2"
              v-if="employee.phones.find((p) => p.type === 'cellphone')"
            >
              TÉLÉPHONES
            </div>
            <div
              v-for="(phone, index) in employee.phones"
              :key="`phone-${index}`"
            >
              <v-checkbox
                class="px-3 my-0"
                v-if="phone.type === 'cellphone'"
                :label="phone.number"
                v-model="phone.config.whitepages"
                color="blue-grey lighten-1"
                @click="autosave"
                dense
              ></v-checkbox>
            </div>
            <div class="subtitle-2 mt-5">PHOTO</div>
            <v-checkbox
              class="my-0 px-3"
              label="Afficher ma photo dans l'annuaire du site web de l'École"
              v-model="employee.pictureRights"
              color="blue-grey lighten-1"
              dense
              @click="autosave"
            ></v-checkbox>
            <div>
              Attention : tout changement effectué ici ne sera pas immédiat et
              peut nécessiter jusqu'à 24 heures pour être pris en compte.
            </div>
            <div class="mt-4">
              Pour autoriser la publication de votre photo dans Outlook, merci
              de consulter ce
              <a href="https://my.hes-so.ch/pwm/private/login" target="_blank"
                >lien</a
              >.
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="8">
        <v-card outlined>
          <v-card-text class="pa-15"
            ><div class="text-center">
              <img
                :src="photo"
                :alt="`${employee.firstname} ${employee.lastname}`"
                height="180"
                v-if="employee.pictureRights"
              />
              <v-avatar color="grey" size="100" v-else>
                <span class="white--text headline"
                  >{{ employee.firstname.charAt(0)
                  }}{{ employee.lastname.charAt(0) }}</span
                >
              </v-avatar>
              <div class="headline mt-3">
                {{ employee.firstname }} {{ employee.lastname }}
              </div>
              <div
                class="body-1"
                v-for="(entity, index) in employee.entities"
                :key="`entity-${index}`"
              >
                {{ entity.displayName }}
              </div>
              <div>E-mail: {{ employee.email }}</div>
              <div v-if="employee.phones.find((p) => p.type === 'landline')">
                Prof.:
                {{ employee.phones.find((p) => p.type === "landline").number }}
              </div>
              <div
                v-if="
                  employee.phones.find((p) => p.type === 'cellphone') &&
                  employee.phones.find((p) => p.type === 'cellphone').config
                    .whitepages
                "
              >
                Mob.:
                {{ employee.phones.find((p) => p.type === "cellphone").number }}
              </div>
              <v-divider class="my-5"></v-divider>
              <div
                v-for="(role, index) in employee.roles"
                :key="`role-${index}`"
              >
                <div v-if="role.config.whitepages">
                  <div v-if="specialRequest.indexOf(role.longName) > -1">
                    {{
                      role[
                        role.longName !== "Maître d'enseignement"
                          ? role.config.labels.whitepages
                          : "longName"
                      ]
                    }}
                  </div>
                  <div v-if="specialRequest.indexOf(role.longName) === -1">
                    {{
                      shortNameDisplay.indexOf(role.longName) > -1
                        ? role.shortName
                        : role[role.config.labels.whitepages]
                    }}
                  </div>
                </div>
              </div>
              <v-divider class="my-5"></v-divider>
              <div>Site de {{ employee.address.location }}</div>
              <div>{{ employee.address.street }}</div>
              <div>{{ employee.address.city }}</div>
            </div></v-card-text
          >
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: [
    "employee",
    "autosave",
    "photo",
    "switchMode",
    "shortNameDisplay",
    "specialRequest",
  ],
  data: () => ({ professor: true }),
};
</script>
